import type { LeaderboardSubmitter } from "@yjsgames/leaderboard";
import type { AnalyticsSink } from "@yjsgames/analytics-ports";
import { AnalyticsEvent } from "../analytics/analyticsEvents.js";

/**
 * 챕터 랭킹 리더보드 sink 데코레이터 — chapter_clear 이벤트의 `chapter` 점수를 리더보드 제출기로 보낸다
 * (`PlatformTaggingSink`/`GpgsAchievementSink`와 동형, 투명). 모든 이벤트는 inner로 그대로 위임.
 *
 * 제출기는 추상 LeaderboardSubmitter<number>(@yjsgames/leaderboard)라 플랫폼(GPGS/Game Center) 불문.
 * 제출은 graceful(미가용/실패 흡수)이라 결과를 기다리지 않는다(fire-and-forget).
 */
export class ChapterLeaderboardSink implements AnalyticsSink {
  constructor(
    private readonly inner: AnalyticsSink,
    private readonly chapterLeaderboard: LeaderboardSubmitter<number>,
  ) {}

  log(event: string, params?: Record<string, string | number>): void {
    this.inner.log(event, params);
    if (event !== AnalyticsEvent.ChapterClear) return;
    const chapter = Number(params?.["chapter"]);
    if (Number.isFinite(chapter)) void this.chapterLeaderboard.submit(chapter);
  }
}
